import React, { useContext } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './B2BAccordion.css';
import { generateClassName } from './helpers';
import { LoginContext } from '../../App';

const B2BAccordion = ({ title, icon, className, rolesAllowed = [], children: content, ...props }) => {
    const { loginData } = useContext(LoginContext);
    const hasRole = rolesAllowed.length === 0 || rolesAllowed.some(role => loginData.roles.includes(role));

    return (
        <>
            {hasRole ? (
                <>
                    <Accordion {...props} className={generateClassName("b2b-accordion", "-container", className)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={generateClassName("b2b-accordion", "-summary", className)}
                        >
                            {icon && <span className="icon">{icon}</span>}
                            <Typography>{title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            className={generateClassName("b2b-accordion", "-details", className)}
                        > {content}
                        </AccordionDetails>
                    </Accordion>
                </>
            ) : null}
        </>
    );
};

export default B2BAccordion;